import BonusBuyButtonComponent from "./bonus-buy-button/bonus-buy-button";
import QuickHitComponent from "./quickhit/quickhit-component";
import BonusWheelComponent from "./bonus-wheel/bonus-wheel";
import BackgroundComponent from "./background/background";
import MessagesComponent from "./messages/messages";
import BonusBuyComponent from "./bonus-buy/bonus-buy";
import HarleyComponent from "./harley/harley";
import ReelAnimationsComponent from "./matrix/reel-animations";
import FreespinsWheelSpins from "./freespins-wheel/freespins-wheel-spins";
import FreespinsWheelBoosters from "./freespins-wheel/freespins-wheel-boosters";
import FreespinsMeterComponent from "./freespins-meter/freespins-meter";
import BannerComponent from "slotworks/components/banner/banner-component";
import FreespinsIntroComponent from "./freespins-wheel/freespins-intro";
import FreespinsBigWinComponent from "./freespins/freespins-bigwin";
import { BigWinTierConfig } from "slotworks/config/component-config-schema";

class HarleyComponents {

    public background: BackgroundComponent;
    public bonusBuyButton: BonusBuyButtonComponent;
    public bonusBuy: BonusBuyComponent;
    public bonusWheel: BonusWheelComponent;
    public harley: HarleyComponent;
    public messages: MessagesComponent;
    public quickHit: QuickHitComponent;
    public reelAnimations: ReelAnimationsComponent;
    public freespinsWheelSpins: FreespinsWheelSpins;
    public freespinsWheelBoosters: FreespinsWheelBoosters;
    public freespinsMeter: FreespinsMeterComponent;
    public banners: BannerComponent;
    public freespinsIntro: FreespinsIntroComponent;
    public freespinsBigWin: FreespinsBigWinComponent;
    
    constructor() {

    }

    public init() {
        this.background = new BackgroundComponent();
        this.bonusBuyButton = new BonusBuyButtonComponent();
        this.bonusBuy = new BonusBuyComponent()
        this.quickHit = new QuickHitComponent();
        this.bonusWheel = new BonusWheelComponent();
        this.messages = new MessagesComponent();
        this.harley = new HarleyComponent();
        this.reelAnimations = new ReelAnimationsComponent();
        this.freespinsWheelSpins = new FreespinsWheelSpins();
        this.freespinsWheelBoosters = new FreespinsWheelBoosters();
        this.freespinsMeter = new FreespinsMeterComponent();
        this.banners = new BannerComponent();
        this.freespinsIntro = new FreespinsIntroComponent();
        this.freespinsBigWin = new FreespinsBigWinComponent();
        this.initFreespinsBigWin();
    }

    public initFreespinsBigWin() {
        const configs:BigWinTierConfig[] = [
            {
                "threshold": 15,
                "countTime": 3500,
                "waitTime": 3400,
                "scene": "bigWin"
            },
            {
                "threshold": 35,
                "countTime": 3400,
                "waitTime": 3000,
                "scene": "megaWin"
            },
            {
                "threshold": 60,
                "countTime": 3100,
                "waitTime": 2800,
                "scene": "superMegaWin"
            },
            {
                "threshold": 100,
                "countTime": 3500,
                "waitTime": 2200,
                "scene": "epicWin"
            }
        ];
        configs.forEach(element => {
            this.freespinsBigWin.addWinTier(element);    
        });
        
    }
}

export default new HarleyComponents();